import axios from 'axios'
import auth from '../utils/auth'
import cfg from '../utils/config'

const getEquipamentos = async () => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/equipamento/'

    const config = {
        headers: {
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.get(requestURL, config)
        return response.data.results
    } catch (error) {
        console.error('Erro ao buscar equipamentos:', error)
        return []
    }
}

const getEquipamento = async (idEquipamento) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/equipamento/${idEquipamento}/`

    const config = {
        headers: {
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.get(requestURL, config)
        return response.data
    } catch (error) {
        console.error('Erro ao buscar equipamento:', error)
        return {}
    }
}

const getEquipamentosByMonitorado = async (idMonitorado) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/monitorado-equipamento/${idMonitorado}/`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.get(requestURL, config)

        return {
            equipamentos: response.data.equipamentos ?? [],
            campos: response.data.campos ?? []
        }

    } catch (error) {
        console.error('Erro ao buscar equipamentos por monitorado:', error)
        return {
            equipamentos: [],
            campos: []
        }
    }
}

const getCamposEquipamento = async (idEquipamento) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/campo-customizado/?equipamento=${idEquipamento}`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.get(requestURL, config)

        return (response.data?.results ?? []).map((field) => ({
            label: field.descricao,
            value: field.id,
            special_operator: field.operador_especial
        }))

    } catch (error) {
        console.error('Erro ao buscar campos do equipamento:', error)
        return []
    }
}

const getChaveDadosAoVivo = async () => {
    const requestURL = cfg.base_api_url + cfg.api_v2 + '/chave-dados-ao-vivo/'

    const config = {
        headers: {
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.get(requestURL, config)
        return response.data
    } catch (error) {
        console.error('Erro ao buscar chave de dados ao vivo:', error)
        return null
    }
}

export {
    getEquipamentos,
    getEquipamento,
    getEquipamentosByMonitorado,
    getCamposEquipamento,
    getChaveDadosAoVivo
}
